module.exports = __webpack_public_path__ + "static/media/Goway_main.7e1808b9.svg";